export default "/images/4783a381b3eb42610ccf6f4e552c7814.avif";